import { FunctionComponent } from 'react';

import { useNavigateToEdit } from '../../../../../shared/hooks/use-navigate-to-edit/use-navigate-to-edit.hook';
import Avatar from '../../../../shared/components/ui/Avatar';
import Box from '../../../../shared/components/ui/Box';
import { tableBlack } from '../../../../shared/components/ui/Table/theme/variables/variables';
import Typography from '../../../../shared/components/ui/Typography';
import { WebGameResponseModel } from '../../../models/web-game-response.model';

export const GameThumbnailAndTitleCell: FunctionComponent<{
  row: WebGameResponseModel;
}> = ({ row }: { row: WebGameResponseModel }) => {
  const navigateToEditPage = useNavigateToEdit(row.id as number);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
      }}
    >
      <Avatar
        variant="rounded"
        src={row.thumbnail.downloadLink}
        {...(row.id && {
          onClick: navigateToEditPage,
        })}
        sx={{
          borderRadius: '6px',
          opacity: '100%',
          width: '80px',
          height: '80px',
          marginRight: '25px',
          cursor: 'pointer',
          boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.15)',
        }}
      />
      <Box component={'div'}>
        <Typography
          sx={{
            fontSize: '24px',
            color: tableBlack,
            marginTop: '8px',
            marginBottom: 0,
            cursor: 'pointer',
          }}
          onClick={navigateToEditPage}
        >
          {row.title}
        </Typography>
      </Box>
    </Box>
  );
};
